/**
 * GraphQL errors from a thrown Apollo error. Some resolvers answer with HTTP 500 (e.g.
 * changePassword's "Old password is incorrect"), which Apollo reports as a network error with the
 * GraphQL errors in `networkError.result.errors`.
 */
export function thrownGraphErrors(error: any): { message: string }[] {
  if (error?.graphQLErrors?.length) return error.graphQLErrors;
  const networkErrors = error?.networkError?.result?.errors;
  return Array.isArray(networkErrors) && networkErrors.length ? networkErrors : [];
}

/**
 * Mutations use Apollo's default errorPolicy ('none'), so GraphQL errors are thrown instead of
 * returned. Normalize both into `{ data, errors }` so callers can show the backend message.
 */
export default async function withGraphErrors<T = any>(request: Promise<T>): Promise<any> {
  try {
    return await request;
  } catch (error: any) {
    const graphQLErrors = thrownGraphErrors(error);
    return {
      data: null,
      errors: graphQLErrors.length
        ? graphQLErrors
        : [{ message: error?.message || 'Something went wrong. Please try again.' }],
    };
  }
}
